import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const CreateCustomer = graphql(`
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      __typename
      ... on Customer {
        identifier
      }
      ... on BasicError {
        errorName
        message
      }
    }
  }
`);
